import {DestroyRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LanguageService} from '@core/service/language.service';

@Directive({
  selector: '[isLang]',
  standalone: true,
})
export class IsLangDirective implements OnInit {
  private readonly destroy: DestroyRef = inject(DestroyRef);
  private languageService: LanguageService = inject(LanguageService);

  element?: any;
  key?: string;

  _lang = 'fr';

  memo: any;
  lang: string = this.languageService.currentLang$.value;

  protected readonly templateRef = inject(TemplateRef<any>);
  protected readonly viewContainer = inject(ViewContainerRef);

  ngOnInit() {
    this.languageService
      .getCurrent()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((lang) => {
        this.lang = lang;
        this.updateView();
      });
  }

  @Input()
  set isLang(lang: 'ar' | 'fr') {
    this._lang = lang;
  }

  @Input()
  set isLangElement(element: any) {
    this.element = element;
  }

  @Input()
  set isLangKey(key: any) {
    this.key = key;
  }

  private updateView(): void {
    this.viewContainer.clear();
    if (this.lang === this._lang) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      if (this.element && this.key) {
        this.memo = this.element[this.key];
        delete this.element[this.key];
      }
    }
  }
}
